// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderUnlogged_container__CUGwX","logoContainer":"HeaderUnlogged_logoContainer__34dvU","logo":"HeaderUnlogged_logo__3Wukt","title":"HeaderUnlogged_title__tQvzx"};